import { SVGProps } from 'react';
const SvgPinterest = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_917_420)">
      <path
        d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z"
        fill="#AD2626"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.5952 29.2382C20.8728 32.9561 19.9389 35.637 17.3295 37.5C16.5228 31.8825 18.5133 27.6642 19.4361 23.1822C17.8609 20.5793 19.6254 15.3381 22.9444 16.6277C27.0286 18.2175 19.7017 25.9283 24.8187 26.94C30.1615 27.9945 32.0739 18.8942 28.7629 15.5874C23.977 10.8133 14.4417 14.8616 15.9261 21.6306C16.5244 24.3591 14.4894 25.1358 14.4894 25.1358C12.8411 24.4688 12.6836 22.1595 12.7679 19.9058C12.9572 14.7234 17.5045 11.0944 22.066 10.5909C27.8353 9.95562 33.2497 12.6731 33.996 18.0095C34.8393 24.0303 31.5027 30.9471 25.3326 30.4769C23.6619 30.3498 21.5952 29.2382 21.5952 29.2382Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_917_420">
        <rect width={48} height={48} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPinterest;
